module.exports = __webpack_public_path__ + "static/firstSectionTertiaryImage2-283e4d34dd7da1006ceab1fe70b6f9f1.png";